import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATION } from '@ngrx/router-store';
import { map } from 'rxjs';
import { actions } from './ui.actions';

@Injectable()
export class UiEffects {
    protected readonly actions$ = inject(Actions);

    hideMenuOnNavigation$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ROUTER_NAVIGATION),
            map(() => actions.hideMenu()),
        );
    });
}
